import React from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import { removeHtmlFromString, replaceBRTags, isModifierKeyPressed } from "../../utils/HTMLUtils";

class EditableText extends React.Component {
  //called once after initial rendering
  componentDidMount() {
    ReactDOM.findDOMNode(this).focus();
  }

  //called before component is removed from DOM, perform cleanup here
  componentWillUnmount() {
    const doc = this._getDoc();
    if (this.props.onEdit) {
      this.props.onEdit(this.getText());
    }
  }

  _onPaste = (e) => {
    const { buttonElement } = this.props;
    e.preventDefault();
    const doc = this._getDoc();

    let pastedText = e.clipboardData.getData("text/plain");

    // Remove HTML from pasted text if this is a button element
    if (buttonElement) {
      pastedText = removeHtmlFromString(pastedText);
    }

    doc.execCommand("insertText", false, pastedText);
  };

  _onBlur = (e) => {
    if (this.props.onEdit) {
      this.props.onEdit(this.getText(), e);
    }
  };

  _onKeyDown = (e) => {
    const { onEditComplete, buttonElement } = this.props;

    // Block specific formatting shortcuts for button text
    if (buttonElement) {
      const styleKeys = ["b", "i", "u"];

      if (isModifierKeyPressed(e) && styleKeys.includes(e.key.toLowerCase())) {
        e.preventDefault();
        return;
      }
    }

    if (
      e.key === "Escape" ||
      e.keyCode === 27 ||
      ((e.key === "Enter" || e.keyCode === 13) && buttonElement)
    ) {
      e.preventDefault();
      if (onEditComplete) {
        onEditComplete();
      }
    }
  };

  getText = () => {
    let node = ReactDOM.findDOMNode(this);

    let result = {
      text: node.innerHTML,
      sample: this._transformText(node),
    };

    return result;
  };

  _transformText = (node) => {
    const hasList = node.querySelectorAll("li").length > 0;

    if (hasList) {
      return node.innerHTML
        .replace(/<li[^>]*>/g, ", ")
        .replace(/<[^>]*>/g, "")
        .replace(",", " - ")
        .substr(0, 30);
    }

    const text = replaceBRTags(node.innerHTML);
    return removeHtmlFromString(text).substr(0, 30);
  };

  _getDoc = () => ReactDOM.findDOMNode(this).ownerDocument;

  render() {
    const { text, className, elementId, buttonElement } = this.props;

    let style = {
      width: "100%",
      height: "100%",
      outline: "none",
      wordWrap: "normal",
      display: "inline-block",
    };

    if (buttonElement) {
      const buttonStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      };

      style = _.merge(style, buttonStyles);
    }

    style = _.merge(style, this.props.style);

    return (
      <div
        id={elementId}
        style={style}
        className={className}
        contentEditable="true"
        onKeyDown={this._onKeyDown}
        onPaste={this._onPaste}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }
}

export default EditableText;
